export default "__VITE_ASSET__964f86d7__"